import { FileType } from '../../Elements/FileTypeResource'
import { ContentAsset } from '../../../swagger/models/ContentAsset'

export function getValidAssetKeys(assets: ContentAsset[] = []): number[] {
  return assets.reduce<number[]>((acc, asset) => {
    const { filetype, assetKey } = asset
    if (
      filetype === FileType.Audio ||
      (filetype === FileType.Video && typeof assetKey === 'number')
    ) {
      acc.push(assetKey)
    }
    return acc
  }, [])
}
